import styles from './Footer.module.css'

export function Footer() {
  return (
    <footer className={styles.footer}>
      <h2>AppFlix &copy; Desenvolvido por Marcos Silva 2024.</h2>
    </footer>
  )
}
